// Brand styling shared between the Search page and its components.

export const BRAND_BG = 'bg-emerald-800';
export const BRAND_TEXT = 'text-emerald-800';
